import { Languages } from '@/lib/dictionaries';

export function convertLanguageCode(languageName: string): Languages {
  let userLanguage = 'en';
  if (languageName === '한국어') {
    userLanguage = 'ko';
  } else if (languageName === '日本語') {
    userLanguage = 'ja';
  } else if (languageName === 'Bahasa Indonesia') {
    userLanguage = 'id';
  } else if (languageName === '简体中文') {
    userLanguage = 'zh';
  }

  return userLanguage as 'ko' | 'en' | 'ja' | 'id' | 'zh';
}

export function convertLanguageName(
  languageCode: string,
  allowSpacing: boolean = false,
): '한국어' | 'English' | '日本語' | 'BahasaIndonesia' | '简体中文' {
  let userLanguage = 'English';
  if (languageCode === 'ko') {
    userLanguage = '한국어';
  } else if (languageCode === 'ja') {
    userLanguage = '日本語';
  } else if (languageCode === 'id') {
    userLanguage = allowSpacing ? 'Bahasa Indonesia' : 'BahasaIndonesia';
  } else if (languageCode === 'zh') {
    userLanguage = '简体中文';
  }

  return userLanguage as
    | '한국어'
    | 'English'
    | '日本語'
    | 'BahasaIndonesia'
    | '简体中文';
}

export function convertRealLanguageName(
  languageCode: string,
  allowSpacing: boolean = false,
): '한국어' | 'English' | '日本語' | 'Bahasa Indonesia' | '简体中文' {
  let userLanguage = 'English';
  if (languageCode === 'ko') {
    userLanguage = '한국어';
  } else if (languageCode === 'ja') {
    userLanguage = '日本語';
  } else if (languageCode === 'id') {
    userLanguage = allowSpacing ? 'Bahasa Indonesia' : 'Bahasa Indonesia';
  } else if (languageCode === 'zh') {
    userLanguage = '简体中文';
  }

  return userLanguage as
    | '한국어'
    | 'English'
    | '日本語'
    | 'Bahasa Indonesia'
    | '简体中文';
}
